export enum DataBlockType {
  PRIVATE_MARKETS_FUNDS = 'private_markets_funds',
}
